import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 bg-sage-100/50 border-y border-sage-200" data-id="element-36">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-37">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-white rounded-full shadow-md mb-6 text-coral-500" data-id="element-38">
          <ShieldCheck size={40} strokeWidth={1.5} data-id="element-39" />
        </div>

        <h2 className="text-3xl font-serif font-bold text-dark-900 mb-6" data-id="element-40">
          Garantía Total de 7 Días
        </h2>

        <p className="text-lg text-dark-800 mb-8 leading-relaxed" data-id="element-41">
          Si en 7 días no ves resultados o no estás completamente satisfecha, te
          devolvemos el 100% de tu dinero. Sin preguntas. Sin complicaciones. Tu
          transformación está garantizada o tu dinero de regreso.
        </p>

        <div className="inline-flex items-center gap-2 px-6 py-2 bg-white rounded-full shadow-sm border border-sage-200 text-sage-700 font-bold text-sm" data-id="element-42">
          🛡️ GARANTÍA 100% SATISFACCIÓN
        </div>
      </div>
    </section>;
}